/**
 * PBI 479416: size dependency artwork around the current location using its
 * configured inset on each side; keep the original size without layout data.
 */
export const getDependencyDimensions = (
  dependency,
  { width, height } = {}
) => ({
  width:
    width > 0 && dependency?.left !== undefined
      ? width + 2 * dependency.left
      : dependency?.width,
  height:
    height > 0 && dependency?.top !== undefined
      ? height + 2 * dependency.top
      : dependency?.height,
})
